import { styled } from '@glitz/react';

export const bareListDecorator = styled({
  margin: { xy: 0 },
  padding: { xy: 0 },
  listStyle: 'none',
});
